import { useContext } from 'react'

import ThirdPartyManagementStepperContext from 'contexts/ThirdPartyManagementStepperContext'

const useThirdPartyManagementStepper = () => {
  const context = useContext(ThirdPartyManagementStepperContext)

  if (context === undefined) {
    throw new Error(
      'useThirdPartyManagementStepper must be used within a ThirdPartyManagementStepperContext.Provider',
    )
  }

  return {
    activeStep: context.activeStep,
    companySupplier: context.companySupplier,
    companySupplierId: context.companySupplierId,
    handleAdvanceStep: context.handleAdvanceStep,
    handleBack: context.handleBack,
    handleNext: context.handleNext,
    handleReturnStep: context.handleReturnStep,
    handleStep: context.handleStep,
    fromCreate: context.fromCreate,
    isCompleted: context.isCompleted,
    isEdit: context.isEdit,
    isShow: context.isShow,
    isLoading: context.isLoading,
    isPreAvaliation: context.isPreAvaliation,
    refresh: context.refresh,
    resetAdvanceStep: context.resetAdvanceStep,
    resetReturnStep: context.resetReturnStep,
    setActiveStep: context.setActiveStep,
    setCompanySupplierId: context.setCompanySupplierId,
    setIsLoading: context.setIsLoading,
    setShowButtons: context.setShowButtons,
    showButtons: context.showButtons,
    wantsToAdvanceStep: context.wantsToAdvanceStep,
    wantsToReturnStep: context.wantsToReturnStep,
  }
}

export default useThirdPartyManagementStepper
